/* eslint-disable react-hooks/exhaustive-deps */
import { debounce } from 'lodash';
import { useEffect } from 'react';

import { useFilterStore } from 'src/stores/filters/filters.store';
import { Option } from 'src/types/common/option';

export const useFilter = (getData: (filters?: any) => void, title: string) => {
  const { filters, setFilters, removeFilter } = useFilterStore((state) => state);
  const statusOptions = [
    { label: 'Ativo', value: 'true' },
    { label: 'Inativo', value: 'false' },
  ];

  const onSearch = debounce((value: string) => {
    if (value.length > 0 && value !== '') {
      setFilters({ ...(value && { promotionName: value }) });
    } else {
      removeFilter('promotionName');
    }
  }, 1000);

  const handleSelectStatus = (option: Option) => {
    if (!option) {
      removeFilter('isActive');
    } else {
      setFilters({ ...(option && { isActive: option.value === 'true' }) });
    }
  };

  useEffect(() => {
    getData();
  }, [filters]);

  return {
    onSearch,
    statusOptions,
    handleSelectStatus,
  };
};
